// ShortsRow.js
import { connect } from 'react-redux';

import FeedStoryProvider from '../container/FeedStoryProvider.js';
import FeedMessages from '../component/FeedMessages.jsx';

const mapStateToProps = (state, { category }) => {
  return {
    isShorts: true,
    moreLink: `/shorts-categories/${category}`,
  };
};

export default FeedStoryProvider(connect(mapStateToProps)(FeedMessages));
